export default __webpack_public_path__ + "static/media/4.d68d2c4a.jpg";